import React from 'react'
import { Marker } from 'react-leaflet'

const LineDistance = ({ position, text, zIndexOffset }) => position
  ? (
    <Marker
      position={position}
      icon={window.L.divIcon({
        className: 'distance-icon', html: `<p>${text}</p>`
      })}
      zIndexOffset={zIndexOffset}
    />
    )
  : null

export default LineDistance
